import * as amplitude from '@amplitude/analytics-browser';

export const initializeAmplitude = (apiKey: string, options?: amplitude.Types.BrowserOptions) => {
    try {
      amplitude.init(apiKey, undefined, options);
    } catch (error) {
      console.error('Error initializing Amplitude:', error);
    }
};

export const trackAmplitudeEvent = (eventName: string, eventProperties?: Record<string, unknown>) => {
  if (!import.meta.env.VITE_AMPLITUDE_API_KEY) {
    console.log('Amplitude events are not being tracked');
    return;
  }
  try {
    amplitude.track(eventName, eventProperties);
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};
